import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from './data.service';
import { Observable } from 'rxjs';
import { EquipmentFilter } from '../model/equipment-filter';
import { CenterFilter } from '../model/center-filter';
import { ReplacementEquipment } from '../model/replacement-equipment';
import { SectorFilter } from '../model/sector-filter';
import { EquipmentExtraordinaryResponse } from '../model/equipment-extraordinary-response';

@Injectable()
export class EquipmentService {

  constructor(private http: HttpClient,
    private dataService: DataService) { }
  private readonly getEquipmentsFilterEndPoint: string = '/equipment/GetEquipmentsFilter/';
  private readonly getEquipmentsFilterByPhysicianEndPoint: string = '/equipment/getEquipmentFilterByPhysician/';
  private readonly getEquipmentFiltersByExtraordinaryEndPoint: string = '/equipment/getEquipmentFiltersByExtraordinary/';
  private readonly getCentersFilterEndPoint: string = '/equipment/GetCentersFilter/';
  private readonly getReplacementEquipmentFilterEndPoint: string = '/equipment/getReplacementEquipmentFilter/';
  private readonly getSectorsFilterEndPoint: string = '/equipment/getSectorsFilter/';
  private readonly replacementMedicalApponitmentEquipmentEndPoint: string = '/equipment/replacementMedicalApponitmentEquipment/';

  async replacementMedicalApponitmentEquipment(replacementEquipment: ReplacementEquipment): Promise<boolean> {
    return await this.dataService.post<boolean>(this.replacementMedicalApponitmentEquipmentEndPoint, replacementEquipment).toPromise();
  }

  async getReplacementEquipmentFilter(medicalAppointmentId: number): Promise<EquipmentFilter[]> {
    const params = { medicalAppointmentId: medicalAppointmentId };
    return await this.dataService.get<EquipmentFilter[]>(this.getReplacementEquipmentFilterEndPoint, params).toPromise();
  }

  async getEquipmentFiltersByExtraordinary(serviceId: number, sectorId?: number): Promise<EquipmentExtraordinaryResponse> {
    const params = {serviceId: serviceId,
                    sectorId: sectorId};
    return await this.dataService
    .get<EquipmentExtraordinaryResponse>(this.getEquipmentFiltersByExtraordinaryEndPoint, params).toPromise();
  }

  async getEquipmentsFilter(): Promise<EquipmentFilter[]> {
    const params = {};
    return await this.dataService.get<EquipmentFilter[]>(this.getEquipmentsFilterEndPoint, params).toPromise();
  }

  async getEquipmentFilterByPhysician(physicianId: number): Promise<EquipmentFilter[]> {
    const params = { physicianId };
    return await this.dataService.get<EquipmentFilter[]>(this.getEquipmentsFilterByPhysicianEndPoint, params).toPromise();
  }

  async getSectorsFilter(): Promise<SectorFilter[]> {
    const params = {};
    return await this.dataService.get<SectorFilter[]>(this.getSectorsFilterEndPoint, params).toPromise();
  }

  async getCentersFilter(): Promise<CenterFilter[]> {
    const params = {};
    return await this.dataService.get<CenterFilter[]>(this.getCentersFilterEndPoint, params).toPromise();
  }
}
